import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, CalculatorIcon, MessageCircleIcon, PackageIcon, CalendarIcon, BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const bonuses = [{
    title: 'Checklist de arranque',
    desc: '(para no olvidar lo importante).',
    icon: <CalculatorIcon className="w-6 h-6 text-gold-matte" data-id="element-44" />,
    number: '1',
    price: 5000
  }, {
    title: 'Plantilla de costos y precios',
    desc: '(para que los números te queden claros).',
    icon: <MessageCircleIcon className="w-6 h-6 text-gold-matte" data-id="element-45" />,
    number: '2',
    price: 12000
  }, {
    title: 'Guiones para WhatsApp',
    desc: '(respuestas y seguimiento sin quedarte en blanco).',
    icon: <PackageIcon className="w-6 h-6 text-gold-matte" data-id="element-46" />,
    number: '3',
    price: 9000
  }, {
    title: 'Paquetes y extras',
    desc: '(cómo armar combos que se venden mejor).',
    icon: <CalendarIcon className="w-6 h-6 text-gold-matte" data-id="element-47" />,
    number: '4',
    price: 7000
  }, {
    title: 'Calendario de fechas',
    desc: '(para planificar campañas y picos de demanda).',
    icon: <BookOpenIcon className="w-6 h-6 text-gold-matte" data-id="element-48" />,
    number: '5',
    price: 6000
  }, {
    title: 'Fuentes y referencias',
    desc: '(para seguir aprendiendo con orden).',
    icon: <ClipboardCheckIcon className="w-6 h-6 text-gold-matte" data-id="element-49" />,
    number: '6',
    price: 7000
  }];
  const totalValue = bonuses.reduce((sum, b) => sum + b.price, 0);
  return <section className="py-20 md:py-28 bg-[#EFE8E0] relative" data-id="element-50">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-52">
          <div className="inline-block bg-red-600 text-white font-black text-xl md:text-2xl px-6 py-2 rounded-full mb-6 transform -rotate-2 shadow-lg animate-pulse" data-id="element-53">
            ¡GRATIS HOY CON TU COMPRA!
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-coffee-dark mb-6 font-heading" data-id="element-54">
            Además, llevás 6 bonos para implementar más rápido
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl border-t-8 border-gold-matte overflow-hidden mb-16" data-id="element-55">
          <a href="https://cocinaproductiva.com/cart/46911022334105:1" target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-56">
            <div className="flex flex-col lg:flex-row" data-id="element-57">
              {/* Image */}
              <div className="lg:w-5/12 p-8 flex items-center justify-center bg-[#f5f0ea]" data-id="element-58">
                <img src="https://cdn.magicpatterns.com/uploads/qsyWribdgrB32WLVj8QUQR/Portada_Ebook_Bonos.png" alt="Los 6 bonos incluidos" className="w-full max-w-sm h-auto rounded-lg drop-shadow-xl" data-id="element-59" />
              </div>

              {/* Bonus list */}
              <div className="lg:w-7/12 p-8" data-id="element-60">
                <div className="space-y-5" data-id="element-61">
                  {bonuses.map((bonus, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.4,
                  delay: index * 0.08
                }} className="flex items-start gap-4 pb-5 border-b border-beige-sand last:border-b-0 last:pb-0" data-id="element-62">
                      <div className="flex-shrink-0 mt-1" data-id="element-63">{bonus.icon}</div>
                      <div className="flex-1" data-id="element-64">
                        <h3 className="text-lg md:text-xl font-bold text-coffee-dark font-heading leading-tight" data-id="element-65">
                          Bono {bonus.number}:{' '}
                          <span className="text-coffee" data-id="element-66">{bonus.title}</span>
                        </h3>
                        <p className="text-text-body font-medium italic text-sm mt-0.5" data-id="element-67">
                          {bonus.desc}
                        </p>
                        <div className="mt-1.5 flex items-center gap-3 flex-wrap" data-id="element-68">
                          <p className="text-taupe font-bold text-sm" data-id="element-69">
                            Valor:{' '}
                            <span className="line-through" data-id="element-70">
                              ${bonus.price.toLocaleString('es-AR')}
                            </span>
                          </p>
                          <span className="inline-block bg-green-100 text-green-800 font-bold px-2.5 py-0.5 rounded text-xs" data-id="element-71">
                            ✅ INCLUIDO HOY GRATIS
                          </span>
                        </div>
                      </div>
                    </motion.div>)}
                </div>

                <div className="mt-6 pt-5 border-t-2 border-gold-matte text-center" data-id="element-72">
                  <p className="text-coffee-dark font-bold text-lg" data-id="element-73">
                    Valor total de los bonos:{' '}
                    <span className="line-through text-taupe" data-id="element-74">
                      ${totalValue.toLocaleString('es-AR')}
                    </span>
                  </p>
                  <span className="inline-block bg-green-100 text-green-800 font-extrabold px-4 py-1.5 rounded-lg text-base mt-2" data-id="element-75">
                    ✅ TODO INCLUIDO GRATIS HOY
                  </span>
                </div>
              </div>
            </div>
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-76">
          <p className="text-2xl text-coffee-dark font-bold italic mb-10 bg-white p-6 rounded-xl shadow-sm border border-beige-sand" data-id="element-77">
            "No es 'más PDFs': son herramientas para ejecutar lo del ebook sin
            reinventar la rueda."
          </p>

          <CTAButton size="large" onClick={() => {
          const el = document.getElementById('offer-section');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });else window.open('https://cocinaproductiva.com/cart/46911022334105:1', '_blank');
        }} data-id="element-78">
            QUIERO EL EBOOK + LOS 6 BONOS GRATIS
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}